import { render } from "./LauncherPage.vue?vue&type=template&id=0b50ef68&ts=true"
import script from "./LauncherPage.vue?vue&type=script&lang=ts"
export * from "./LauncherPage.vue?vue&type=script&lang=ts"

import "./LauncherPage.vue?vue&type=style&index=0&id=0b50ef68&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__